/**
 * Authentication Domain - Client-safe API
 *
 * Import from this file in Client Components ('use client').
 * Contains only hooks, types, and errors — no server-only dependencies.
 *
 * For server-only exports (repositories, services), use '@/contexts/authentication'.
 */

// Hooks (Client-side)
export { useCurrentUser } from './hooks/useCurrentUser';
export type { CurrentUser, UseCurrentUserResult } from './hooks/useCurrentUser';
export { useTelegramMiniApp } from './hooks/useTelegramMiniApp';
export { useCurrentUserContext } from './components/CurrentUserProvider';

// Components
export { default as SigninModal } from './components/SigninModal';

// Types (safe for client — no runtime code)
export type {
  Session,
  SessionUpdate,
  JWTPayload
} from './types/session';


export type {
  AuthenticatedPageSession
} from './services/PageAuthService';

export type { User, Account } from './types/user';

